import React, { useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/3g4ZtijZwYmFSLEMVG4xap/Captura_de_pantalla_2026-03-08_224029.png',
  alt: 'Portada del tomo de Ciencias Sociales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aULup3FUfhEh87Dm22boDW/Captura_de_pantalla_2026-03-08_224117.png',
  alt: 'Guía de lectura y contenidos del tomo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5tXNkBaxqqtFhPjRrTVis2/Captura_de_pantalla_2026-03-08_224129.png',
  alt: 'Los tres momentos de la intensificación'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hq6ugNKZu4DDasPQgTaEwi/Captura_de_pantalla_2026-03-08_224142.png',
  alt: 'Cómo leer este material y Módulo de Historia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uyf1r5dvw7LLXDAbKAbBP6/Captura_de_pantalla_2026-03-08_224156.png',
  alt: 'Encuadre curricular y propósitos del módulo'
}];
export function ProductPreviewSection() {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent(c => c === 0 ? previewImages.length - 1 : c - 1);
  const next = () => setCurrent(c => c === previewImages.length - 1 ? 0 : c + 1);
  return <section className="bg-[#F9F9F9] py-20 px-4" data-id="element-171">
      <div className="max-w-5xl mx-auto" data-id="element-172">
        {/* Title */}
        <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-173">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-174">
            Miralo por dentro: así es el MegaPack
          </h2>
          <p className="text-lg text-gray-600" data-id="element-175">
            Deslizá para ver algunas páginas reales del primer tomo.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative max-w-4xl mx-auto" data-id="element-176">
          {/* Arrow Left */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 md:-translate-x-6 z-10 w-10 h-10 md:w-12 md:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors border border-gray-200" aria-label="Imagen anterior" data-id="element-177">
            <ChevronLeft className="w-5 h-5 md:w-6 md:h-6 text-[#1A1A1A]" data-id="element-178" />
          </button>

          {/* Image Container */}
          <div className="overflow-hidden rounded-2xl shadow-xl border border-gray-200 bg-white" data-id="element-179">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${current * 100}%)`
          }} data-id="element-180">
              {previewImages.map((img, i) => <div key={i} className="w-full flex-shrink-0" data-id="element-181">
                  <img src={img.src} alt={img.alt} className="w-full h-auto object-contain" loading={i === 0 ? 'eager' : 'lazy'} width="800" height="1131" decoding="async" data-id="element-182" />
                </div>)}
            </div>
          </div>

          {/* Arrow Right */}
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 md:translate-x-6 z-10 w-10 h-10 md:w-12 md:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors border border-gray-200" aria-label="Imagen siguiente" data-id="element-183">
            <ChevronRight className="w-5 h-5 md:w-6 md:h-6 text-[#1A1A1A]" data-id="element-184" />
          </button>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2.5 mt-6" data-id="element-185">
            {previewImages.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`rounded-full transition-all duration-300 ${i === current ? 'w-8 h-3 bg-[#00BCD4]' : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-186" />)}
          </div>
        </div>

        {/* Footer text */}
        <p className="text-center text-gray-600 text-lg mt-10 max-w-2xl mx-auto" data-id="element-187">
          Esto es solo una muestra. El MegaPack completo tiene decenas de
          recursos organizados para vos.
        </p>
      </div>
    </section>;
}